export default "__VITE_ASSET__KYm99Brh__"